export const SupportIconSVG = ({ className }) => (
    <svg
        className={className}
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.1666 8.00423C14.1666 7.71589 14.1666 7.57173 14.2099 7.44339C14.3358 7.07006 14.6683 6.92589 15.0016 6.77423C15.3749 6.60339 15.5616 6.51839 15.7474 6.50339C15.9574 6.48673 16.1683 6.53173 16.3483 6.63256C16.5866 6.76589 16.7533 7.02089 16.9233 7.22756C17.7091 8.18256 18.1024 8.66006 18.2458 9.18589C18.3624 9.61089 18.3624 10.0559 18.2458 10.4801C18.0366 11.2484 17.3741 11.8917 16.8833 12.4884C16.6324 12.7926 16.5066 12.9451 16.3483 13.0342C16.1652 13.1358 15.9561 13.1807 15.7474 13.1634C15.5616 13.1484 15.3749 13.0634 15.0008 12.8926C14.6674 12.7409 14.3358 12.5967 14.2099 12.2234C14.1666 12.0951 14.1666 11.9509 14.1666 11.6626V8.00423ZM5.83326 8.00423C5.83326 7.64089 5.82326 7.31506 5.52992 7.06006C5.42326 6.96756 5.28159 6.90339 4.99909 6.77423C4.62492 6.60423 4.43826 6.51839 4.25242 6.50339C3.69659 6.45839 3.39742 6.83839 3.07742 7.22839C2.29076 8.18256 1.89742 8.66006 1.75326 9.18673C1.63726 9.61032 1.63726 10.0573 1.75326 10.4809C1.96326 11.2484 2.62659 11.8926 3.11659 12.4884C3.42576 12.8634 3.72159 13.2059 4.25242 13.1634C4.43826 13.1484 4.62492 13.0634 4.99909 12.8926C5.28242 12.7642 5.42326 12.6992 5.52992 12.6067C5.82326 12.3517 5.83326 12.0259 5.83326 11.6634V8.00423Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.1665 6.5C4.1665 3.73833 6.77817 1.5 9.99984 1.5C13.2215 1.5 15.8332 3.73833 15.8332 6.5M15.8332 13.1667V13.8333C15.8332 15.3058 14.3415 16.5 12.4998 16.5H10.8332"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default SupportIconSVG;